export const buildWishlistProduct = (
  item: FlattenedWishlistItem,
  index: number,
  locale?: Locales,
): ProductDataLayer => {
  const { productId, quantity, flatProduct } = item

  if (flatProduct) {
    return mapProductToDataLayer(flatProduct, locale ?? 'en-AU', {
      wishlisted: true,
      position: index,
    })
  }

  return {
    position: index + 1,
    id: productId ?? '',
    quantity,
  }
}

export const buildWishList = (wishlist: FlattenedWishlist, locale?: Locales): WishListDataLayer => {
  if (!wishlist || wishlist.length <= 0) {
    return {
      products: [],
    }
  }

  const products: ProductDataLayer[] = wishlist
    .filter((item: FlattenedWishlistItem) => item.type === 'product')
    .map((item: FlattenedWishlistItem, index: number) => ({
      ...buildWishlistProduct(item, index, locale),
    }))

  return {
    products,
  }
}

export function buildWishlistPayload(
  isAdd: boolean = false,
  wishlist: FlattenedWishlist,
  products: any[],
  location: string,
  locale?: Locales,
  mapProduct?: boolean,
  position?: number | undefined,
) {
  let ecommerce

  if (mapProduct) {
    products = products.map((product) => {
      return mapProductToDataLayer(product, locale ?? 'en-AU', {
        wishlisted: true,
        position,
      })
    })
  }

  if (isAdd) {
    ecommerce = {
      wishlistAdd: {
        products,
      },
    }
  } else {
    ecommerce = {
      wishlistRemove: {
        products,
      },
    }
  }

  const payload = {
    group: 'wishlist',
    info: { location },
    ecommerceType: isAdd ? 'wishlist-add' : 'wishlist-remove',
    ecommerce,
    wishlist: buildWishList(wishlist, locale),
  }

  return payload
}
